const Grafikon = () => {
  return (
    <div className="clanak-page" id="clanak-page">
      <img
        src="/images/grafikon.jpg"
        className="clanak-img"
        alt="ison background"
      />
    </div>
  );
};

export default Grafikon;
